import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type {
  TypeGetShippingLabelsShippingLabelIdParams,
  TypeGetShippingLabelsShippingLabelIdResponse,
} from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 운송장 상세 조회 API
 */
const fetchShippingLabelsShippingLabelId = async (
  params: TypeGetShippingLabelsShippingLabelIdParams
): Promise<TypeGetShippingLabelsShippingLabelIdResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetShippingLabelsShippingLabelIdResponse>(
    `${API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPING_LABEL_DETAIL}/${params.shippingLabelId}`
  );
  return data.data;
};

/**
 * [운송장 관리] 운송장 상세 조회 Mutation Hook
 */
export const useGetShippingLabelsShippingLabelIdMutation = () => {
  return useMutation({
    mutationFn: fetchShippingLabelsShippingLabelId,
  });
};
